import { useParams } from 'react-router-dom'

export const useCurrentId = () =>
	useParams<{ conversation?: string }>()?.conversation ?? ''
